import React, { useState } from "react";
import { useLink } from "../../../../contexts/LinkContext";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import { useFile } from "../../../../contexts/FileContext";
import Dropzone from "../../../../components/Dropzone";
import { EditableFile } from "../../../../models/EditableFile";
import FileListItem from "../../../FileListPage/FileListItem";
import { Field } from "../../../../design/fieldset";
import UploadFilesDialog from "../../../../components/UploadFilesDialog";

interface EventFilesListProps {
  eventId: string;
}

const EventFilesList = ({ eventId }: EventFilesListProps) => {
  const { links } = useLink();
  const { files } = useFile();
  const [editableFiles, setEditableFiles] = useState<EditableFile[]>([]);

  const eventLinks = links.filter(
    (link) => link.fromType === "File" && link.toId === eventId,
  );
  const fileIds = eventLinks.map((link) => link.fromId);
  const filteredFiles = files.filter((file) => fileIds.includes(file._id));

  return (
    <div className="gap-4 space-y-4">
      <UploadFilesDialog
        type="evidence"
        eventId={eventId}
        isOpen={editableFiles.length > 0}
        files={editableFiles}
        setFiles={setEditableFiles}
        onClose={() => setEditableFiles([])}
      />
      <Field>
        <Dropzone files={editableFiles} setFiles={setEditableFiles} />
      </Field>
      {filteredFiles.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader className="text-left">Name</TableHeader>
              <TableHeader className="text-left">Size</TableHeader>
              <TableHeader className="text-right">Last Updated</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredFiles.map((file) => (
              <FileListItem key={file._id} file={file} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default EventFilesList;
